// extracted by mini-css-extract-plugin
export default {"root":"AdminNav_root__9Yr9I","tab":"AdminNav_tab__-iVZ4"};